import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from "react-router-dom";
import { GetInstituteInformation, GetOneInstituteAllCourses, GetOneInstituteTrainingStats } from '../../../Actions/StudentA';
import { BaseUrl } from '../../../Actions/Base';
import InstituteExcellenceAwarded from './ExcellenceAwarded';
import TrainingHoursAndStaffs from './TrainingHoursAndStaff';
import CourseOfferings from "./CourseOfferings"
import Footer from '../../../Components/Footer/Footer';
import DirectionIcon from "../Assets/directionIcon.svg";
import { Link } from "react-router-dom";
import "./InstituteDetails.css"

const EnrolledCourseInstituteDetails = () => {
    const { InstituteId } = useParams();
    console.log("InstituteId in useparams is:",InstituteId);
    const dispatch = useDispatch();
    const { InstituteInformation, InstituteAllCoursesInformation, InstituteTrainingStats, loading } = useSelector((Store) => Store.StudentReducer);
    console.log("InstituteInformation in EnrolledCourseInstituteDetails is:",InstituteInformation);
    console.log("InstituteAllCoursesInformation in EnrolledCourseInstituteDetails is:",InstituteAllCoursesInformation);
    console.log("InstituteTrainingStats in EnrolledCourseInstituteDetails is:",InstituteTrainingStats);

    useEffect(() => {
        if(InstituteId){
            dispatch(GetInstituteInformation(InstituteId))
            dispatch(GetOneInstituteAllCourses(InstituteId))
            dispatch(GetOneInstituteTrainingStats(InstituteId))
        }
      }, [dispatch, InstituteId]);

    const { timeSlots, instituteDetails, userDetails, courses, awards, totalStudentReviews, averageRating } = InstituteInformation;

    const weekDays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

    function getDayRange(startDay, endDay) {
    const startIndex = weekDays.indexOf(startDay);
    const endIndex = weekDays.indexOf(endDay);
    return weekDays.slice(startIndex, endIndex + 1);
    }

    const mergeTimeSlots = (timeSlots, gapThreshold = 30) => {
        if (!timeSlots || timeSlots.length === 0) return [];
    
        // Convert time to minutes
        const timeToMinutes = (time) => {
            const [hours, minutes] = time.split(":").map(Number);
            return hours * 60 + minutes;
        };
    
        // Convert minutes to AM/PM format
        const minutesToTime = (minutes) => {
            const hours = Math.floor(minutes / 60);
            const mins = minutes % 60;
            const ampm = hours >= 12 ? 'PM' : 'AM';
            const hour12 = hours % 12 || 12;  // Convert to 12-hour format
            const formattedMinutes = mins < 10 ? `0${mins}` : mins;
            return `${hour12}:${formattedMinutes} ${ampm}`;
        };
    
        // Sort time slots by StartTime
        const sortedSlots = timeSlots.sort((a, b) => timeToMinutes(a.StartTime) - timeToMinutes(b.StartTime));
    
        const merged = [];
        let currentRange = { start: sortedSlots[0].StartTime, end: sortedSlots[0].EndTime };
    
        for (let i = 1; i < sortedSlots.length; i++) {
            const { StartTime, EndTime } = sortedSlots[i];
    
            const prevEndTime = timeToMinutes(currentRange.end);
            const currentStartTime = timeToMinutes(StartTime);
    
            // Calculate the gap between the end of the current range and the start of the next slot
            const gap = currentStartTime - prevEndTime;
    
            // If the gap is smaller than or equal to the threshold, merge the slots
            if (gap <= gapThreshold) {
                currentRange.end = EndTime;
            } else {
                // If the gap is larger than the threshold, finalize the current range and start a new one
                merged.push(`${minutesToTime(timeToMinutes(currentRange.start))} - ${minutesToTime(timeToMinutes(currentRange.end))}`);
                currentRange = { start: StartTime, end: EndTime };
            }
        }
    
        // Push the last accumulated range
        merged.push(`${minutesToTime(timeToMinutes(currentRange.start))} - ${minutesToTime(timeToMinutes(currentRange.end))}`);
    
        return merged;
    };
    
    // Ensure InstituteInformation?.timeSlots is an array before reducing
    const groupedTimeSlots = Array.isArray(InstituteInformation?.timeSlots)
    ? InstituteInformation.timeSlots.reduce((acc, slot) => {
        if (!acc[slot.DayOfWeek]) acc[slot.DayOfWeek] = [];
        acc[slot.DayOfWeek].push(slot);
        return acc;
    }, {})
    : {}; // Default to empty object if undefined

    const handleDirectionClick = () => {
        if (!instituteDetails?.address) {
            console.error("Institute address is missing!");
            return;
        }
    
        const instituteAddress = encodeURIComponent(instituteDetails.address);
        const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${instituteAddress}`;
        window.open(mapsUrl, "_blank");
    };
    
    
    return (
        <>
        <div className=" flex flex-col items-center bg-bgPurpal mt-[80px] pb-[20px] lg:pb-[0px] rounded-b-[60px] lg:rounded-b-none">
        <div className="h-[2px] hidden lg:block w-full bg-white"></div>
        <h2 className="h-[72px] content-center text-center font-segoe-ui text-3xs text-white md:text-base xl:text-lg">
            About Institute
        </h2>
        <div className="h-[2px] hidden lg:block w-full bg-white"></div>
  
        <div
          className={`flex h-auto lg:min-h-[430px] w-full
               flex-col 
               md:flex-row 
               overflow-hidden	
              `}
        >
          <div className="flex w-full w-[100%] md:w-[80%] lg:w-[60%] text-[#FFFFFF]">
            <div className="w-full flex justify-center w-[100%] lg:w-[80%] pt-[10px] lg:pt-[60px]">
                <div className='w-[90%] lg:w-[70%] flex flex-col gap-[10px]'>
                    <div className='flex items-center gap-[10px]'>
                        <div  className="relative flex items-center justify-center overflow-hidden rounded-full text-center h-[70px] w-[70px]"
                            >
                            <img
                                className="absolute w-full"
                                src={
                                    instituteDetails
                                        ? `${BaseUrl}/api/vehicletype/image?url=${instituteDetails?.logo}`
                                        : null
                                }
                                alt="Logo"
                            />
                        </div>
                        <p className='text-[26px] lg:text-[50px] font-bold'>{instituteDetails?.name}</p>
                    </div>

                    {averageRating > 0 && ( 
                    <div className='lg:hidden flex items-center gap-[10px]'>
                        {averageRating && ( 
                            <div className='flex gap-[2px]'>
                                {[...Array(averageRating)].map((_, index) => (
                                <img
                                    key={index}
                                    className='w-[14px] sm:w-auto'
                                    src={require('../Assets/StarIcon.svg').default}
                                    alt='Star'
                                />
                                ))} 
                            </div>
                        )}
                        {totalStudentReviews && (
                        <p className='text-[16px]'>Reviewed by {totalStudentReviews} Students</p>
                        )}

                        <img className='h-3' src={require('../Assets/ThumbIcon.svg').default} alt="" />
                        <p className='text-[15px] SemiBold'>
                            | {averageRating * 20}%
                        </p>
                    </div>
                    )}
                            
                    {/* <div className='flex flex-col gap-[5px] mt-[10px] lg:mt-[0px]'>
                        <p className='text-[20px] font-bold'>Working Hours</p>
                        <div className="mt-2 flex flex-col gap-[10px]">
                            {timeSlots?.map((slot, idx) => {
                                const days = getDayRange(slot.StartDayOfWeek, slot.EndDayOfWeek);
                                return days.map((day) => (
                                <div key={`${idx}-${day}`}>
                                    {day}: {slot.StartTime} - {slot.EndTime}
                                </div>
                                ));
                            })}
                            {timeSlots && (
                                <p>Break Time: {timeSlots[0]?.StartBreakTime} - {timeSlots[0]?.EndBreakTime}</p>
                            )}
                         {Object.entries(groupedTimeSlots).map(([day, times]) => (
                            <div key={day} className="w-full lg:w-[70%] flex justify-between ">
                                <p className='text-[18px]'>{day}</p>
                                <p className='text-[16px]'>{mergeTimeSlots(times, 30).join(", ")}</p>
                            </div>
                        ))} 
                        </div>
                    </div> */}

                    <div className="flex flex-col gap-2 mt-2 lg:mt-0 text-[#FFFFFF]">
                        <p className="text-lg font-bold">Office Working Hours</p>
                        <div className="mt-2 flex flex-col gap-2">
                            {timeSlots?.map((slot, idx) => {
                            const days = getDayRange(slot.StartDayOfWeek, slot.EndDayOfWeek);
                            return days.map((day) => (
                                <div
                                key={`${idx}-${day}`}
                                className="flex items-center gap-4"
                                >
                                <span className="w-[100px] text-[18px]">{day}</span>
                                <span className="w-[150px]  text-[16px]">
                                    {slot.StartTime} - {slot.EndTime}
                                </span>
                                </div>
                            ));
                            })}
                            {timeSlots && (
                            <div className="flex items-center gap-4 mt-2">
                                <span className="w-[100px] text-[18px]">Break Time</span>
                                <span className="w-[150px] text-[16px]">
                                {timeSlots[0]?.StartBreakTime} - {timeSlots[0]?.EndBreakTime}
                                </span>
                            </div>
                            )}
                        </div>
                    </div>


                    <div className='flex flex-col w-full mt-[30px] lg:mt-[10px]'>
                        <div className='flex w-full gap-[10px]'>
                            <p className='text-[18px]'>Address:</p>
                            <p className='text-[18px]'>{instituteDetails?.address}</p>
                        </div>

                        <div className='flex w-full gap-[10px]'>
                            <p className='text-[18px]'>Email:</p>
                            <p className='text-[18px]'>{userDetails?.Email}</p>
                        </div>

                        <div className='flex w-full gap-[10px] pb-[0px] lg:pb-[15px] '>
                            <p className='text-[18px]'>Phone Number:</p>
                            <p className='text-[18px]'>{userDetails?.PhoneNumber}</p>
                        </div>
                    </div>
                </div>

                <div className='w-[10%] hidden lg:flex flex-col h-[72%] justify-between'>
                    <div className='flex flex-col gap-[5px] mt-[20px]'>
                        {totalStudentReviews > 0 && (
                            <p className='text-[18px] w-[300px]'>Reviewed by {totalStudentReviews} Students</p>
                        )}
                        {averageRating > 0 && ( 
                        <div className='flex gap-[10px]'>
                            {[...Array(averageRating)].map((_, index) => (
                                    <img
                                    key={index}
                                    className="w-[14px] sm:w-auto"
                                    src={require('../Assets/StarIcon.svg').default}
                                    alt="Star"
                                    />
                                ))}
                            {/* <img className='w-[14px] sm:w-auto' src={require('../Assets/StarIcon.svg').default} alt="" />
                            <img className='w-[14px] sm:w-auto' src={require('../Assets/StarIcon.svg').default} alt="" />
                            <img className='w-[14px] sm:w-auto' src={require('../Assets/StarIcon.svg').default} alt="" />
                            <img className='w-[14px] sm:w-auto' src={require('../Assets/StarIcon.svg').default} alt="" />
                            <img className='w-[14px] sm:w-auto' src={require('../Assets/StarIcon.svg').default} alt="" /> */}
                        </div>
                        )}

                        {averageRating > 0 && (
                        <div className='flex gap-[10px]'>
                            <img className='h-5 cursor-pointer ' src={require('../Assets/ThumbIcon.svg').default} alt="" />
                            <p className='text-[18px] SemiBold'>
                               {averageRating * 20}%
                            </p>
                        </div>
                        )}

                        <p className='text-[14px] w-[200px]'>
                            {courses > 10 ? "10+ Courses" : `${courses} Courses`}
                        </p>
                    </div>

                    <Link to={`/enrolledcourse/institutelocation/${InstituteId}`}  target="_blank"  className="no-underline">
                        <div className='ml-[0px] flex justify-center items-center gap-[5px] w-[150px] h-[50px] bg-[#A1A3EF] text-[#FFFFFF] rounded-[9px] cursor-pointer'
                        >
                            <img className='w-[30px]' src={DirectionIcon} alt="DirectionIcon" />
                            <p className='text-[18px]'>Direction</p>
                        </div>
                    </Link>
                </div>
            </div>
        
          </div>

          <div className='w-full flex lg:hidden justify-center items-center mt-[50px]'>
                <div>
                    <div className='ml-[40px] flex justify-center items-center gap-[5px] w-[150px] h-[50px] bg-[#A1A3EF] text-[#FFFFFF] rounded-[9px] cursor-pointer'
                        onClick={handleDirectionClick}>
                        <img className='w-[30px]' src={DirectionIcon} alt="DirectionIcon" />
                        <p className='text-[18px]'>Direction</p>
                    </div>
                </div>
            </div>
  
          <div className=" relative hidden lg:flex bg-bgPurpal w-[40%]" >
            <img
                className={`diagonal-image absolute right-0 left-[-21px] w-[120%] h-full object-cover`}
                src={
                    instituteDetails
                        ? `${BaseUrl}/api/vehicletype/image?url=${instituteDetails?.banner}`
                        : null
                }
                alt="Banner"
            />
            {/* <img
              className="absolute right-0 left-[-21px] h-full w-[120%]"
              src={require("../Assets/diagonalImage.png")}
              alt="img"
             
            /> */}
          </div>
        </div>
        </div>
        
        {InstituteAllCoursesInformation?.courses?.length > 0 && (
            <CourseOfferings InstituteAllCoursesInformation={InstituteAllCoursesInformation} />
        )}

        {awards?.length > 0 && (
            <InstituteExcellenceAwarded awards={awards} />
        )}

        {InstituteTrainingStats && (
            <TrainingHoursAndStaffs courses={courses}
            awards={awards}
            InstituteTrainingStats={InstituteTrainingStats} />
        )}

        <Footer />

        {/* <div className='p-[100px]'>

        </div> */}
      </>
    )
}

export default EnrolledCourseInstituteDetails